import React from 'react';
import classNames from 'classnames';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import { useFormLogin } from 'src/controllers/LoginPage/LoginController';
import LoadingScreen from 'src/components/LoadingScreen';

import logoImg from 'src/assets/logo_azul.png';
import { useAuth } from 'src/contexts/auth';

const LoginPage: React.FC = () => {
    const formik = useFormLogin();
    const { signInFailed, loading, toast } = useAuth();

    if (loading) {
        return (
            <LoadingScreen />
        )
    }

    return (
        <div style={{ height: '100vh' }} className="p-d-flex p-jc-center p-ai-center">
            <Toast ref={toast} />
            <div className="card p-p-6">
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-justify-center p-pb-6" style={{ width: '10em', height: "100%", margin: '0 auto' }}>
                        <img src={logoImg} alt="InforFrota" style={{ width: "100%", height: 'auto' }} />
                    </div>
                    <div id="form-help">
                        {
                            signInFailed ?
                                <small
                                    id="form-help"
                                    className="p-invalid p-d-block p-pl-5"
                                >
                                    Falha no login. Tente novamente!
                                </small>
                                :
                                <></>
                        }
                        <div className="p-field">
                            <div className="p-pr-5 p-pl-5 p-pt-1">
                                <span className="p-float-label p-input-icon-left">
                                    <i className="pi pi-user"></i>
                                    <InputText id="email" placeholder="Email"
                                        {...formik.getFieldProps('email')}
                                        onChange={formik.handleChange('email')}
                                    />
                                </span>
                            </div>
                            <div className={classNames("p-invalid popup-fade p-pr-5 p-pl-5", {
                                'popup-form-active': formik.touched.email && formik.errors.email,
                                'popup-form-inactive': !(formik.touched.email && formik.errors.email),
                            })}
                            >{formik.errors.email}</div>
                        </div>

                        <div className="p-field">
                            <div className="p-pr-5 p-pl-5 p-pt-3">
                                <span className="p-float-label p-input-icon-left">
                                    <i className="pi pi-lock"></i>
                                    <Password id="password" placeholder="Senha"
                                        feedback={false}
                                        {...formik.getFieldProps('password')}
                                        onChange={formik.handleChange('password')}
                                    />
                                </span>
                            </div>
                            <div className={classNames("p-invalid popup-fade p-pr-5 p-pl-5", {
                                'popup-form-active': formik.touched.password && formik.errors.password,
                                'popup-form-inactive': !(formik.touched.password && formik.errors.password),
                            })}
                            >{formik.errors.password}</div>
                        </div>
                    </div>
                    <div className="p-fluid p-grid p-p-5 p-justify-center">
                        <div className="p-col-12 ">
                            <Button
                                type="submit"
                                label="Entrar"
                                icon="pi pi-sign-in"
                                iconPos="right"
                                onClick={() => formik.handleSubmit()}
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default LoginPage;

